import { api } from './api';

export type Scope = 'ALL' | 'ASSIGNED' | 'CREATED';
export type Module = 'services' | 'tasks' | 'invoices';

export interface RoleAccessSettings {
  roleId: string;
  roleName: string;
  isSystemRole: boolean;
  settings: Record<Module, Scope[]>;
}

export interface RoleAccessSettingsResponse {
  settings: RoleAccessSettings[];
  modules: Module[];
  scopes: Scope[];
  scopesByModule: Record<Module, Scope[]>;
}

export const roleAccessSettingApi = {
  /**
   * Get all role access settings
   */
  getAll: async (): Promise<RoleAccessSettingsResponse> => {
    const response = await api.get('/role-access-settings');
    return response.data.data;
  },

  /**
   * Get settings for a specific role
   */
  getByRole: async (roleId: string): Promise<RoleAccessSettings> => {
    const response = await api.get(`/role-access-settings/role/${roleId}`);
    return response.data.data;
  },

  /**
   * Update settings for a role
   */
  updateByRole: async (
    roleId: string,
    settings: Record<Module, Scope[]>
  ): Promise<RoleAccessSettings> => {
    const response = await api.put(`/role-access-settings/role/${roleId}`, {
      settings,
    });
    return response.data.data;
  },

  /**
   * Reset role settings to defaults
   */
  resetToDefault: async (roleId: string): Promise<RoleAccessSettings> => {
    const response = await api.post(`/role-access-settings/role/${roleId}/reset`);
    return response.data.data;
  },
};

export default roleAccessSettingApi;
